export interface CaseStudyClient {
  initials: string;
  name: string;
  role: string;
}

export interface CaseStudy {
  id: string;
  title: string;
  tags: string[];
  image: { src: string; srcSet: string };
  description: string;
  client: CaseStudyClient;
}

const hero = (base: string) => ({
  src: `/assets/services/${base}.jpg`,
  srcSet: [
    `/assets/services/${base}.avif 1x`,
    `/assets/services/${base}.webp 1x`,
  ].join(", "),
});

export const CASE_STUDIES: CaseStudy[] = [
  {
    id: "lived-in-blonde",
    title: "Lived-in blonde",
    tags: ["Babylights", "Root melt", "Gloss"],
    image: hero("03_honey_blonde_dimensional_waves_4x5"),
    description:
      "Hand-painted ribbons across the crown with a soft root melt. Grow-out after 14 weeks still reads dimensional, not banded.",
    client: { initials: "JM", name: "Jessica M.", role: "Manhattan Beach" },
  },
  {
    id: "brunette-gloss",
    title: "Brunette gloss & grey blending",
    tags: ["Demi gloss", "Grey blending"],
    image: hero("05_ash_blonde_couture_foil_4x5"),
    description:
      "Translucent demi-permanent glaze on a natural-grey base. Softened contrast without erasing silver.",
    client: { initials: "SK", name: "Sarah K.", role: "Redondo Beach" },
  },
  {
    id: "extensions",
    title: "Custom extensions",
    tags: ["Hand-tied", "Calibrated tone"],
    image: hero("04_espresso_silk_length_4x5"),
    description:
      "Hand-tied additions matched for curl, density, and color across three light sources. Seamless at the seam, naturally wearable.",
    client: { initials: "LS", name: "Lauren S.", role: "Hermosa Beach" },
  },
];
